import { mailRegex, telRegex, nameRegex } from '../../../regex';

export const formAddProfSchema = {
  firstname: {
    presence: {
      allowEmpty: false,
      message: '^Ce champs est requis'
    },
    format: {
      pattern: nameRegex,
      message: '^Veuillez entrer un prénom valide'
    }
  },
  lastname: {
    presence: { allowEmpty: false, message: '^Ce champs est requis' },
    format: {
      pattern: nameRegex,
      message: '^Veuillez entrer un nom valide'
    }
  },
  email: {
    presence: { allowEmpty: false, message: '^Ce champs est requis' },
    format: {
      pattern: mailRegex,
      message: '^Veuillez entrer un mail valide'
    }
  },
  tel: {
    presence: { allowEmpty: false, message: '^Ce champs est requis' },
    length: {
      is: 10,
      message: `^Le numéro de téléphone doit contenir 10 chiffres.`
    },
    format: {
      pattern: telRegex,
      message: '^Vous devez renseignez un numéro de téléphone'
    }
  }
};
